import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {

  transform(name: string | null | undefined): string {
    const words = (name || '').trim().split(/\s+/).filter((x) => x);
    if (!words.length) {
      return '';
    }
    const first = Array.from(words[0])[0];
    const last = words.length > 1 ? Array.from(words[words.length - 1])[0] : '';
    return (first + last).toUpperCase();
  }

}
